export interface IAsset {
  description: string;
  links: {
    self: string;
  };
  stages: string[];
  title: string;
  type: string;
  thumbnail?: string;
}

export interface IAssetCategory {
  type: string;
  name: string;
  assets?: IAsset[];
  subcategories?: IAssetCategory[];
}

export enum Assets {
  video = 'Video',
  pdf = 'PDF',
}

export const MIN_SCREEN_SIZE_FOR_MORE_ITEMS = 833;
export const VISIBLE_TRACK_DEFAULT_WIDTH = 926;
export const MIN_DEFAULT_SCREEN_SIZE = 985;
